import React from 'react';
import { FieldValues } from 'react-hook-form';
import { ApiServerHandlerOptions, handleApiServerError } from '@cp/utils/apiServer/errorHandler';
import { SerializedError } from '@reduxjs/toolkit';
import { ApiServerError } from '@cp/utils/rtk/query/model';
import { useToast } from '@cp/shared/toast';

export const useApiServerErrorHandler = () => {
  const createToast = useToast();

  return React.useCallback(
    <F extends FieldValues = FieldValues, FC = unknown>(
      error: SerializedError | ApiServerError,
      options: ApiServerHandlerOptions<F, FC> = {},
    ) => {
      const onUnhandledError = (payload: { message: string }) => {
        createToast('error', payload.message);
        options.onUnhandledError?.(payload);
      };
      return handleApiServerError(error, { ...options, onUnhandledError });
    },
    [createToast],
  );
};
